module.exports = __webpack_public_path__ + "img/couples-036.a19817d2.jpg";